import React, { useEffect } from "react";
import { useLang } from "@/context/LanguageContext";
import { useSettings } from "@/context/SettingsContext";
import { Mail, MessageSquare, MapPin, Building2 } from "lucide-react";

export default function ContactPage() {
  const { t, lang } = useLang();
  const { company } = useSettings();
  useEffect(() => {
    document.title = lang === "da" ? "Kontakt | Belov Multiservice" : "Contact | Belov Multiservice";
  }, [lang]);

  const rows = [
    company?.phone && { icon: MessageSquare, label: t.contact.sms, value: company.phone, href: `sms:${company.phone.replace(/\s/g, "")}` },
    company?.email && { icon: Mail, label: t.contact.email, value: company.email, href: `mailto:${company.email}` },
    company?.city && { icon: MapPin, label: t.contact.city, value: company.city },
    company?.cvr && { icon: Building2, label: t.contact.cvr, value: company.cvr },
  ].filter(Boolean);

  return (
    <div data-testid="contact-page">
      <section className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="text-3xl sm:text-5xl font-display font-extrabold tracking-tight text-stone-900">{t.contact.title}</h1>
        <p className="mt-4 text-lg text-stone-600">{t.contact.subtitle}</p>
        <div className="mt-8 bg-white border border-stone-200 rounded-2xl divide-y divide-stone-100">
          {rows.map((r, i) => (
            <div key={i} className="flex items-center gap-4 p-5" data-testid={`contact-row-${i}`}>
              <div className="w-11 h-11 rounded-xl bg-[#F4F1EA] flex items-center justify-center"><r.icon className="w-5 h-5 text-[#1E3A2F]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-stone-400 font-semibold">{r.label}</div>
                {r.href ? <a href={r.href} className="text-lg font-semibold text-stone-900 hover:text-[#1E3A2F]">{r.value}</a>
                  : <div className="text-lg font-semibold text-stone-900">{r.value}</div>}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
